import CategoryHead from "../../../../components/categoryhead";
import React from "react";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import { connect } from "react-redux";
import { closePanel } from "../../../../../redux/ui/library/actions";
import PropTypes from "prop-types";
import { OffScreenComponent } from "../../../../components/mixins";
import { Translation } from "../../../../core/translate";

const BackContainer = styled.div`
  width: 100%;
  height: 62px;
  flex-basis: 62px;
  flex-grow: 0;
  flex-shrink: 0;
  background: ${cloud.getShade(2)};
  align-items: center;
  margin-left: 15px;
  display: none ${styledMedia.small`
    display: flex;
  `};
`;

function PanelBack({ label, onClick }) {
  return (
    <BackContainer>
      <CategoryHead caretLeft onClick={onClick}>
        <OffScreenComponent>
          <Translation id="base.exit" />
        </OffScreenComponent>
        <span aria-hidden="true">{label}</span>
      </CategoryHead>
    </BackContainer>
  );
}

PanelBack.propTypes = {
  label: PropTypes.string.isRequired
};

export default connect(
  null,
  dispatch => ({
    onClick: () => dispatch(closePanel())
  })
)(PanelBack);
